import React, { useEffect, useRef, useState } from "react";
import MoreButton from "../Custom/MoreButton";
import filter from "../../../assets/Imagess/filter.svg";
import faculty from "../../../assets/Imagess/facultyselecticon.svg";
import statusICon from "../../../assets/Imagess/statusIconmodal.svg";
import graduation from "../../../assets/Imagess/graduation.svg";
import CustomizedSelect from "../../Atoms/Inputs/CustomizedSelect";
import { useFetchApplicantStatus } from "../../../Hooks/Applicant";
import { useFetchInterestedStatus } from "../../../Hooks/Interested";
import Buttons from "../../Atoms/Buttons/Buttons";
import styles from "./TableTopHeader.module.css";
import {
  UseFetchFieldOfInterest,
  useFetchFieldOfInterestByAppStart,
} from "../../../Hooks/Settings";

const Filter = ({
  isApplicant,
  selected,
  setProgram,
  setStatus,
  setFieldOfInterest,
  refetch,
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [type, setType] = useState();
  const [selectedField, setSelectedField] = useState();

  const [params, setParams] = useState({
    program: "",
    status: "",
    field: "",
  });
  const { data: applicantOptions, refetch: refetchApplicantStatus } =
    useFetchApplicantStatus();
  const { data: interestedOptions, refetch: refetchInterestedStatus } =
    useFetchInterestedStatus();
  const { data: fieldOfInterestData } = UseFetchFieldOfInterest();
  const {
    data: fieldOfInterestByAppStart,
    refetch: refetchFieldOfInterestByType,
  } = useFetchFieldOfInterestByAppStart(type);

  const selectApplicantOptions = applicantOptions?.data?.map(
    ({ statusId, statusText }) => ({
      value: statusId,
      text: statusText,
    })
  );
  const selectInterestedOptions = interestedOptions?.data?.map(
    ({ statusId, statusText }) => ({
      value: statusId,
      text: statusText,
    })
  );
  useEffect(() => {
    const selectedFieldOfInterest = type
      ? fieldOfInterestByAppStart?.data?.map(({ value, text }) => ({
          value: value,
          text: text,
        }))
      : fieldOfInterestData?.data?.map(({ value, text }) => ({
          value: value,
          text: text,
        }));
    setSelectedField(selectedFieldOfInterest);
  }, [type, fieldOfInterestByAppStart, fieldOfInterestData]);

  const handleShowResult = () => {
    setProgram(params.program);
    setStatus(params.status);
    setFieldOfInterest(params.field);
  };
  const handleReset = () => {
    setParams({
      program: "",
      status: "",
      field: "",
    });
    refetch();
  };
  useEffect(() => {
    setSelectedOptions(
      isApplicant ? selectApplicantOptions : selectInterestedOptions
    );
  }, [isApplicant, selected, applicantOptions, interestedOptions]);

  useEffect(() => {
    refetchApplicantStatus();
    refetchInterestedStatus();
  }, [isApplicant]);

  useEffect(() => {
    refetchFieldOfInterestByType();
  }, [type]);

  return (
    <MoreButton icon={filter} width="400px">
      <div className={styles["filter-container"]}>
        <h4> Filter</h4>
        <CustomizedSelect
          options={[
            { value: 0, text: "Undergraduate" },
            { value: 1, text: "Graduate" },
            { value: 2, text: "Visiting" },
          ]}
          icon={graduation}
          placeholder="Select type"
          value={params.program}
          onChange={(selectedValue) => {
            setParams((prevParams) => ({
              ...prevParams,
              program: selectedValue.value,
            }));
            setType(selectedValue.value);
          }}
        />
        <CustomizedSelect
          options={selectedField}
          icon={faculty}
          placeholder="Select Faculty"
          value={params.field}
          onChange={(selectedValue) =>
            setParams((prevParams) => ({
              ...prevParams,
              field: selectedValue.value,
            }))
          }
        />

        <CustomizedSelect
          options={selectedOptions}
          icon={statusICon}
          placeholder="Select Status"
          value={params.status}
          onChange={(selectedValue) =>
            setParams((prevParams) => ({
              ...prevParams,
              status: selectedValue.value,
            }))
          }
          status={true}
        />
        <div className={styles["filterbutton-container"]}>
          <Buttons text="Reset Filter" handleOnClick={handleReset} />
          <Buttons
            text="Show Result"
            type="Submit"
            handleOnClick={handleShowResult}
          />
        </div>
      </div>
    </MoreButton>
  );
};

export default Filter;
